import { Button, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import React from "react";
import { Styling, CommonUtil as cu } from "../../../../types/elements";
import { StylingResultProps } from "./StylingListView";

interface StylingResultTableProps extends StylingResultProps {}
const StylingResultTable: React.FC<StylingResultTableProps> = ({ list, openDialog, openUser }) => {
  return (
    <div>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>상태/신청일자</TableCell>
            <TableCell>타입</TableCell>
            <TableCell>사이즈</TableCell>
            <TableCell>희망일정</TableCell>
            <TableCell>예산</TableCell>
            <TableCell>유저</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {list.map((r, rIdx) => {
            return (
              <TableRow key={r.id}>
                <TableCell>
                  <Button onClick={() => r.id && openDialog(r.id)}>{r.id}</Button>
                </TableCell>
                <TableCell>
                  {r.status} <br />
                  {r.created && cu.getFormattedDate(r.created, "yyyy-MM-dd")}
                </TableCell>
                <TableCell>{r.areatype}</TableCell>
                <TableCell>{r.areasize}</TableCell>
                <TableCell>{r.expect_month}</TableCell>
                <TableCell>{r.budget}만원</TableCell>
                <TableCell className="noBreakWord">
                  <Button onClick={() => r.user_id && openUser && openUser(r.user_id)}>
                    #{r?.user?.id} {r?.user?.name}
                  </Button>
                  <br />
                  {r?.user?.phone}
                  <br />
                  {r?.user?.email}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

export default StylingResultTable;
